import { GlobalHelper } from "../../indexImports"
import { ListingSortFieldAndOrder } from "../listing/ListingSortField"
import { PriceLevelDto } from "./PriceLevel"
import { PriceLevelListingStore } from "./PriceLevelListingReducer"

export const PriceLevelStateHandler = (state: PriceLevelListingStore) => {
    return {
        setPriceLevels(payload: PriceLevelDto[]): PriceLevelListingStore {
            return { ...state,priceLevels:[...payload] }
        },
        addPriceLevel(payload: PriceLevelDto): PriceLevelListingStore {
            return {
                ...state,
                priceLevels: [...state.priceLevels, payload]
            }
        },
        updatePriceLevel(payload: PriceLevelDto): PriceLevelListingStore {
            const newPriceLevels = state.priceLevels.map(p => {
                if (p.id == payload.id) {
                    return payload
                }
                return p
            })
            return {
                ...state,
                priceLevels: [...newPriceLevels]
            }
        },
        sortPriceLevels(listingSortParam: ListingSortFieldAndOrder): PriceLevelListingStore {
            const orderedPriceLevels: PriceLevelDto[] = state.priceLevels.sort((a: PriceLevelDto, b: PriceLevelDto) => {
                return GlobalHelper.sortStringField(a.attributes.name,b.attributes.name,listingSortParam.sortOrderAsc)
            })
            return { ...state, priceLevels: [...orderedPriceLevels] }
        }
    }
}



// WEBPACK FOOTER //
// ./src/state/price-level/PriceLevelStateHandler.ts